import { useTranslator } from 'components/shared/hooks';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import {
  ROUTE_POLLS,
  ROUTE_POLLS_CREATE,
  ROUTE_POLLS_EDIT,
  ROUTE_POLLS_LIST,
  ROUTE_POLLS_PUBLISH,
  ROUTE_POLLS_RESULTS,
} from 'config/routes';
import React, { FC, Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { relativePath } from 'utils/navigation/relativePath';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { AddPollView } from 'views/Panel/Polls/PollsEditor/AddPoll.view';
import { EditPollView } from 'views/Panel/Polls/PollsEditor/EditPoll.view';
import { PollsListView } from 'views/Panel/Polls/PollsList/PollsList.view';
import { PublishView } from 'views/Panel/Polls/Publish/Publish.view';
import { ResultsView } from 'views/Panel/Polls/Results/Results.view';

export const PollsView: FC = () => {
  const trans = useTranslator();

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.POLLS.POLLS')} static />

      <Routes>
        <Route path={relativePath(ROUTE_POLLS, ROUTE_POLLS)} element={<Navigate to={ROUTE_POLLS_LIST} replace />} />
        <Route path={relativePath(ROUTE_POLLS_LIST, ROUTE_POLLS)} element={<PollsListView />} />
        <Route path={relativePath(ROUTE_POLLS_CREATE, ROUTE_POLLS)} element={<AddPollView />} />
        <Route path={relativePath(ROUTE_POLLS_PUBLISH, ROUTE_POLLS)} element={<PublishView />} />
        <Route path={relativePath(`${ROUTE_POLLS_RESULTS}/*`, ROUTE_POLLS)} element={<ResultsView />} />
        <Route path={relativePath(ROUTE_POLLS_EDIT, ROUTE_POLLS)} element={<EditPollView />} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
